<template>
  <div>
    <template v-for="(item) in menuList">
      <!-- 有次级菜单的,则展开子选项-->
      <el-sub-menu v-if="item.children && item.children.length > 0" :key="item.id" :index="item.id">
        <template #title>
          <el-icon v-if="item.icon != '' && item.icon != null && item.icon != undefined">
            <component :is="item.icon" />
          </el-icon>
          <span :class="[item.parentId == 0 ? 'activespan' : 'disactivesapn']">{{ item.title }}</span>
        </template>
        <!-- 递归,实现无限级展开 -->
        <MenuTree :menuList="item.children"></MenuTree>
      </el-sub-menu>
      <!-- 没有次级菜单的 -->
      <el-menu-item v-if="!item.children" :key="item.id" :index="item.path">
        <el-icon v-if="item.icon != '' && item.icon != null && item.icon != undefined">
          <component :is="item.icon" />
        </el-icon>
        <span :class="[item.parentId == 0 ? 'activespan' : 'disactivesapn']">{{ item.title }}</span>
      </el-menu-item>
    </template>
    <!-- <div @click="parentClick"></div> -->
  </div>
</template>


<script setup name='menustree'>
import MenuTree from '@/components/menu/menustree.vue';
defineProps({
  menuList: {
    type: Array,
    default: []
  },

})
// const emits = defineEmits(['parentClick'])
// 	const clickEmits = () => {
// 		emits('parentClick', 'ddddd')
// 	}
</script>


<style scoped>
.activespan {
  font-size: 18px !important;
}

.disactivesapn {
  margin-left: 30px;
  font-size: 15px !important;
}

/* 菜单栏选中后背景色 */
.el-menu-item {
  color: #ffffff;
}

.el-menu-item.is-active {
  color: #55aaff;
}
</style>